<template>
  <div>
    <RegistrationLayout>
      <template v-slot:header>
        <HMButton
          v-if="step === 2"
          color="white"
          rounded="full"
          size="x-small"
          fontWeight="semibold"
          textSize="small"
          padding="tight"
          @click="back"
        >
          <span>
            <Icon iconClass="fas fa-chevron-left" />
            {{ $t('common.back_btn') }}
          </span>
        </HMButton>
      </template>
      <template v-slot:default>
        <SelecRegistrationModality
          v-if="step === 1"
          :isSSORegister="true"
          @next="step = 2"
        />
        <VerifyIdentityRegistration
          v-if="step === 2"
          :isSSORegister="true"
          @next="step = 3"
        />
        <CommunicationPreferences v-if="step === 3" :isSSORegister="true" />
      </template>
    </RegistrationLayout>
  </div>
</template>

<script>
import SelecRegistrationModality from './verify-identity/SelecRegistrationModality.vue'
import VerifyIdentityRegistration from './verify-identity/VerifyIdentityRegistration.vue'
import CommunicationPreferences from './CommunicationPreferences'
import RegistrationLayout from '@components/layouts/RegistrationLayout'

export default {
  components: {
    SelecRegistrationModality,
    VerifyIdentityRegistration,
    CommunicationPreferences,
    RegistrationLayout,
  },
  data() {
    return {
      step: 1,
    }
  },
  methods: {
    back() {
      this.step--
    },
  },
}
</script>
